import { render, staticRenderFns } from "./NolaNovelSideMenu.vue?vue&type=template&id=a3f0aea4&scoped=true"
import script from "./NolaNovelSideMenu.vue?vue&type=script&lang=ts"
export * from "./NolaNovelSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelSideMenu.vue?vue&type=style&index=0&id=a3f0aea4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f0aea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f0aea4')) {
      api.createRecord('a3f0aea4', component.options)
    } else {
      api.reload('a3f0aea4', component.options)
    }
    module.hot.accept("./NolaNovelSideMenu.vue?vue&type=template&id=a3f0aea4&scoped=true", function () {
      api.rerender('a3f0aea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NolaNovelSideMenu.vue"
export default component.exports